import { render, staticRenderFns } from "./layout-blog-posts.vue?vue&type=template&id=759bd89c&scoped=true"
import script from "./layout-blog-posts.vue?vue&type=script&lang=js"
export * from "./layout-blog-posts.vue?vue&type=script&lang=js"
import style0 from "./layout-blog-posts.vue?vue&type=style&index=0&id=759bd89c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759bd89c",
  null
  
)

export default component.exports